import { ReactNode } from 'react';
import { Typography } from '@mui/material';

interface Props {
  title: string;
  value: ReactNode;
}

export const GWPElement = ({ title, value }: Props) => {
  return (
    <>
      <Typography variant="body2" fontWeight={400}>
        {title}
      </Typography>
      <Typography variant="subtitle2">{value}</Typography>
    </>
  );
};
